import classNames from 'classnames';
import {
  Button,
  FlexContainer,
  Input,
  Spinner,
  TitledBlock,
  Txt,
  ErrorMessage,
} from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useProperty } from 'state';
import styles from './CauseAddEdit.module.scss';

/**
 * CauseAddEdit
 *
 * @return {JSX.Element}
 */
const CauseAddEdit = ({ className, onClose, index }) => {
  const propertyDoc = useProperty();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const isEdit = typeof index === 'number';
  const [value, setValue] = useState(() =>
    isEdit ? propertyDoc.data.clauses[index] || '' : ''
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Submit');
    setIsLoading(true);
    const clauses = [...propertyDoc.data.clauses];
    try {
      if (isEdit) {
        clauses[index] = value;
      } else {
        clauses.push(value);
      }
      propertyDoc.update({
        clauses,
      });
      onClose();
    } catch (e) {
      setIsLoading(false);
      setError(e.message);
    }
  };

  const handleChange = ({ target: { value } }) => {
    setValue(value);
  };

  return (
    <FlexContainer
      className={classNames(
        styles.CauseAddEdit,
        className,
        CauseAddEdit.displayName
      )}
      column
      flex
      gap
    >
      <form onSubmit={handleSubmit}>
        <TitledBlock
          title={`Cause ${
            (isEdit ? index : propertyDoc.data.clauses.length) + 1
          }`}
        >
          <Input
            fullWidth
            required
            autoFocus
            name="Access/Entry devices if lost or broken must be replaced for a fee of £63.00."
            value={value || ''}
            onChange={handleChange}
            disabled={isLoading}
            reverse
            enterKeyHint="send"
          />
        </TitledBlock>
        {error ? <ErrorMessage small description={error} /> : null}
        <FlexContainer>
          <Button flex type="submit" big success disabled={isLoading}>
            {isLoading ? (
              <Spinner />
            ) : (
              <FlexContainer spaceBetween alignCenter flex>
                <Txt xx>Save</Txt>
                <Txt>🎉</Txt>
              </FlexContainer>
            )}
          </Button>
        </FlexContainer>
      </form>
    </FlexContainer>
  );
};

CauseAddEdit.displayName = 'InventoryAddEditScreen';

export default observer(CauseAddEdit);
